<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-center py-0 my-10">
        <!--begin::Title-->
        <h2 class="fs-1x fw-bolder mb-10">
          Lista de Ordenes Judiciales de Ingresos
        </h2>
        <!--end::Title-->

        <!--begin::Description-->
        <p class="text-gray-600 fs-6 fw-bold mb-0">
          <span v-if="rol !== 'supervisor'"
            >{{ nombre_recinto_penitenciario }} -
            {{ departamento_centro_penitenciario }}
          </span>
          <span v-else
            >{{ rol.toUpperCase() }} - DEPARTAMENTO DE
            {{ departamento_supervisar }}</span
          ><br />
          <span> Información actualizada a : {{ currentDate }}</span>
        </p>
        <div class="row">
          <div class="col-md-8 col-md-offset-0">
            <div class="card-body d-flex">
              <buttonNewManualRegistration></buttonNewManualRegistration>
            </div>
          </div>
        </div>
        <!-- <Datatable
          :table-header="tableHeader"
          :table-data="tableData"
          :rows-per-page="5"
          :enable-items-per-page-dropdown="false"
        >
          <template v-slot:cell-invoice="{ row: payment }">
            {{ payment.invoice }}
          </template>
          <template v-slot:cell-juez="{ row: payment }">
            {{ payment.juez }}
          </template>
          <template v-slot:cell-juzgado="{ row: payment }">
            {{ payment.juzgado }}
          </template>
          <template v-slot:cell-nombre_ppl="{ row: payment }">
            {{ payment.nombre_ppl }}
          </template>
          <template v-slot:cell-nro_doc="{ row: payment }">
            {{ payment.nro_doc }}
          </template>
          <template v-slot:cell-actions>
            <div class="col-md-12 mb-4">
              <button type="button" class="btn px-3">
                <i
                  title="Nuevo ingreso"
                  style="font-size: 1.5em; color: Dodgerblue"
                  class="fas fa-circle-plus"
                ></i>
              </button>
              <button type="button" class="btn px-3">
                <i
                  title="Ver resolución"
                  style="font-size: 1.5em; color: Mediumslateblue"
                  class="fas fa-file-pdf"
                ></i>
              </button>
            </div>
          </template>
        </Datatable> -->

        <!--end::Description-->

        <!--begin::Action-->
        <!-- <div class="display:'flex'">
          <button
            type="button"
            class="btn btn-primary er fs-6 px-8 py-4 mx-6"
            data-bs-toggle="modal"
            :data-bs-target="`#${modalId}`"
            data-bs-keyboard="false"
          >
            {{ buttonText }}
          </button>
          <button
            type="button"
            class="btn btn-info er fs-6 px-8 py-4 mx-6"
            @click="listDeprivedLiberty()"
          >
            Lista Privados de libertad
          </button>
        </div> -->
        <!--end::Action-->
      </div>
      <!--end::Heading-->

      <!--begin::Illustration-->
      <!-- <div class="text-center px-5">
        <img :src="image" alt="" class="mw-100 mh-300px" />
      </div> -->
      <!--end::Illustration-->
    </div>
    <!--end::Card body-->
  </div>
  <!--end::Card-->
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import date from "date-and-time";
import es from "date-and-time/locale/es";
import buttonNewManualRegistration from "@/views/buttons/buttonNewManualRegistration.vue";
import useAuth from "@/auth/composables/useAuth";
//import Datatable from "@/components/kt-datatable/KTDatatable.vue";

export default defineComponent({
  name: "CourtOrderList",
  //   props: {
  //     title: String,
  //     description: String,
  //     buttonText: String,
  //     image: String,
  //     modalId: String,
  //   },
  components: {
    //Datatable,
    buttonNewManualRegistration,
  },
  setup() {
    date.locale(es);
    const now = new Date();
    const currentDate = date.format(now, "dddd, DD MMMM YYYY hh:mm:ss");
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
    } = useAuth();

    const tableHeader = ref([
      {
        name: "Acciones",
        key: "actions",
        sortable: false,
      },
      {
        name: "Código Único",
        key: "invoice",
        sortable: true,
      },
      {
        name: "Nombre Juez",
        key: "juez",
        sortable: true,
      },
      {
        name: "Nombre Juzgado",
        key: "juzgado",
        sortable: true,
      },
      {
        name: "Privado de Libertad",
        key: "nombre_ppl",
        sortable: true,
      },
      {
        name: "Documento de identidad",
        key: "nro_doc",
        sortable: true,
      },
    ]);
    const tableData = ref([
      {
        invoice:
          Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) +
          "-" +
          Math.floor(Math.random() * (9999 - 1000 + 1) + 1000),
        description: "Payment for invoice",
        juzgado: "1RO EN LO PENAL LA PAZ",
        // status: {
        //   label: "Pending",
        //   state: "warning",
        // },
        juez: "JUAN CABALLERO MARTINEZ",
        nombre_ppl: "JOSE ARTURO PEREZ RUIZ",
        nro_doc: "8348558",
      },
    ]);

    const deleteRecord = (invoice) => {
      for (let i = 0; i < tableData.value.length; i++) {
        if (tableData.value[i].invoice === invoice) {
          tableData.value.splice(i, 1);
        }
      }
    };

    const router = useRouter();
    const listDeprivedLiberty = () => {
      router.push({ name: "listDeprivedLiberty" });
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Filiación", ["Inicio"]);
    });
    return {
      date,
      currentDate,
      tableHeader,
      tableData,
      deleteRecord,
      listDeprivedLiberty,
      setCurrentPageBreadcrumbs,

      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
    };
  },
});
</script>
